export default __webpack_public_path__ + "static/media/ic_dashboard.08ff112f.svg";